import React from 'react';

import {twx} from '../../utils/tailwindUtils';

const RoundedIcon = ({onClick, className, children}) => {
    return (
        <div
            onClick={onClick}
            className={twx(
                'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-color-light-silver backdrop-blur-xl dark:bg-color-dark-gray',
                'group-[.secondary]:bg-color-romance group-[.secondary]:dark:bg-color-slate-gray',
                'group-[.transparent]:bg-[#EBECEC1A]',
                'group-[.third]:dark:bg-color-slate-gray',
                'group-[.only-light]:bg-color-light-silver',
                className
            )}
        >
            {children}
        </div>
    );
};

export default RoundedIcon;
